import videoImage from '../../assets/images/new-img1.png'
export const PromotionalBanner = () => {
  return (
    <div className="col-12 col-lg-8">
      <div className="card">
        <div className="card-body p-0">
          <div
            id="carouselExampleIndicators"
            className="carousel slide"
            data-ride="carousel"
          >
            <ol className="carousel-indicators">
              <li
                data-target="#carouselExampleIndicators"
                data-slide-to={0}
                className="active"
              />
              <li data-target="#carouselExampleIndicators" data-slide-to={1} />
              <li data-target="#carouselExampleIndicators" data-slide-to={2} />
            </ol>
            <div className="carousel-inner">
              <div className="carousel-item active">
                <img
                  className="d-block w-100 h-270p rounded-15"
                  src={videoImage}
                  alt="First slide"
                />
              </div>
              <div className="carousel-item">
                <img
                  className="d-block w-100 h-270p rounded-15"
                  src={videoImage}
                  alt="Second slide"
                />
              </div>
              <div className="carousel-item">
                <img
                  className="d-block w-100 h-270p rounded-15"
                  src={videoImage}
                  alt="Third slide"
                />
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

  )
}